import "./Investigations.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import RegisterTextbox from "../../components/RegisterTextBox";
import { Form, Spinner } from "react-bootstrap";
import CustomButton from "../../components/CustomButton";
import RegisterTextarea from "../../components/RegisterTextarea";
import UploadInput from "../../components/UploadInput";
import { useState } from "react";
import API from "../../api/axiosConfig";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { borderRadius } from "@mui/system";

function Investigations() {
  const [reason, setReason] = useState("");
  const [investigator, setInvestigator] = useState("");
  const [result, setResult] = useState("");
  const [date, setDate] = useState(new Date().toISOString().substr(0, 10));
  const [description, setDescription] = useState("");
  const [attach, setAttach] = useState("");
  const [error, setError] = useState([]);
  const [message, setMessage] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams();

  const navigate = useNavigate();



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const mForm = new FormData();
    mForm.append("reason", reason);
    mForm.append("investigator", investigator);
    mForm.append("result", result);
    mForm.append("date", date);
    mForm.append("description", description);
    mForm.append("attach", attach);
    mForm.append("employee_id", id);

    try {
      const response = await API.post("/investigations/store", mForm, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const data = await response;
      navigate("/hrreport/investigations");
    } catch (error) {
      console.error(error);
      setError(error.response.data.errors);
      setIsSubmitting(false);
      setMessage(error.response.data.message);
    }

  };


  return (
    <>
      <div className="investigations">
        <Title
          title="إضافة تحقيق"
          icon={<FontAwesomeIcon icon={faPlusCircle} />}
        />

        <Form className="investigationsContainer" onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="investRow">
            <RegisterTextbox
              parentStyle={{ width: "20%" }}
              id="reason"
              label="السبب"
              type="text"
              stylee={{ width: "30%" }}
              name="reason"
              onChange={(e) => setReason(e.target.value)}
              error={error && error.reason}
            />
            {/* {error && error.reason && (
              <div className="error">{error.reason}</div>
            )} */}
            <RegisterTextbox
              parentStyle={{ width: "20%" }}
              id="investigator"
              label="المحقق"
              type="text"
              stylee={{ width: "30%" }}
              name="investigator"
              onChange={(e) => setInvestigator(e.target.value)}
              error={error && error.investigator}
            />
            {/* {error && error.investigator && (
              <div className="error">{error.investigator}</div>
            )} */}
          </div>

          <div className="investRow">
            <RegisterTextbox
              parentStyle={{ width: "20%" }}
              id="result"
              label="النتيجة"
              type="text"
              stylee={{ width: "40%" }}
              name="result"
              onChange={(e) => setResult(e.target.value)}
              error={error && error.result}

            />
            {/* {error && error.result && (
              <div className="error">{error.result}</div>
            )} */}
            <RegisterTextbox
              parentStyle={{ width: "20%" }}
              id="date"
              label="التاريخ"
              type="date"
              stylee={{ width: "30%", border: "3px solid var(--border-color)", borderRadius: "22px" }}
              name="date"
              onChange={(e) => setDate(e.target.value)}
            />
            {/* <div style={{ display: "flex", flexDirection: "column", width: "20%" }}>
              <p style={{ marginBottom: "10px" }}>التاريخ </p>
              <input
                type="date"
                id="date"
                onChange={(e) => setDate(e.target.value)}
                value={date}
                className="custom-datepicker"
                style={{ width: "100%" }}

              />
            </div> */}
            {error && error.date && <div className="error">{error.date}</div>}
          </div>

          <div className="investRow discribtion">
            <RegisterTextarea
            id="description2"
            label="الوصف"
            parentStyle={{
              width: "45%",
              marginBottom: "20px",
            }}
            stylee={{
              height: "100px",
            }}
            rows={5}
            // placeholder="البيانات التي لا تظهر في كارت الحالة"
            name="description"
            onChange={(e) => setDescription(e.target.value)}
            error={error && error.description}
          />
          </div>
          {attach && (
              <div className="image p-0">
                <img className="rounded-4" width={150} src={URL.createObjectURL(attach)} alt="صورة مرفوعة" />
              </div>
          )}
          <UploadInput
            id="documentUpload"
            parentStyle={{
              marginTop: "20px",
              marginBottom: "20px",
              display: "flex",
            }}
            label="إرفاق صورة"
            name="attach"
            onChange={(e) => setAttach(e.target.files[0])}
            error={error && error.attach}
          />
          {/* {error && error.attach && <div className="error">{error.attach}</div>} */}
          {
            isSubmitting ? <Spinner animation="border" variant="primary" /> :
              <CustomButton text="حفظ" className="addClientBtn" />}
        </Form>
      </div>
    </>
  );
}

export default Investigations;
